import { apiConnector } from "../apiConnection";
import toast from "react-hot-toast";

const getToken = () => (typeof window !== "undefined" ? localStorage.getItem("token") : null);

export const addRecurringRequestApi = async (recurrenceGroupId, rideId) => {
  try {
    const token = getToken();
    const request = {
      url: `/api/recurring/request`,
      method: "POST",
      bodyData: { recurrenceGroupId, rideId },
      headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    };
    toast.loading("Sending recurring request...");
    const res = await apiConnector(request);
    if (res.status !== 201) throw new Error(res.data.message || "error occurred");
    toast.dismiss();
    toast.success("Recurring Request sent successfully");
    return true;
  } catch (error) {
    toast.dismiss();
    toast.error(error.message || "Could not send the request");
    return false;
  }
};

export const getRecurringGroupApi = async (recurrenceGroupId) => {
  try {
    const token = getToken();
    const request = {
      url: `/api/recurring/${recurrenceGroupId}`,
      method: "GET",
      headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    };
    const res = await apiConnector(request);
    if (res.status !== 200) throw new Error(res.data.message || "error occurred");
    return res.data;
  } catch (error) {
    toast.error(error.message || "Could not fetch recurring group");
    return null;
  }
};

export const updateRecurringStatusApi = async (recurrenceGroupId, userId, status) => {
  try {
    const token = getToken();
    const request = {
      url: `/api/recurring/status`,
      method: "PATCH",
      bodyData: { recurrenceGroupId, userId, status },
      headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    };
    const res = await apiConnector(request);
    if (res.status !== 200) throw new Error(res.data.message || "error occurred");
    toast.success(`Request ${status.toLowerCase()} successfully`);
    return true;
  } catch (error) {
    toast.error(error.message || "Could not update status");
    return false;
  }
};

export const getRecurringRidesApi = async (recurrenceGroupId) => {
  try {
    const token = getToken();
    const request = {
      url: `/api/recurring/rides/${recurrenceGroupId}`,
      method: "GET",
      headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    };
    const res = await apiConnector(request);
    if (res.status !== 200) throw new Error(res.data.message || "error occurred");
    return res.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};
